<template>
	<div>
		<div v-title data-title="职工港湾"></div>
		<router-view />
	</div>
</template>

<script>
	export default {
		data() {
			return {
				List_1: [],
				List_2: [],
				List_3: [],
				List_4: [],
			};
		},
		mounted() {
			//默认加载token
			this.getToken();
		},
		methods: {
			getToken() {
				let t =
					"eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJJZCI6MCwiQVBQSUQiOjIwMjAxMSwiVXNlcklkIjoiIiwiVXNlck5hbWUiOiIiLCJPcGVuaWQiOiIxMjMiLCJIZWFkaW1ndXJsIjoiIiwiQXV0aG9yaXR5S2V5IjowLCJBdXRob3JpdHlWYWx1ZSI6IkdVRVNUIiwiZXhwIjoxNjY5NDY0MDE3LCJpc3MiOiJoc25tcyIsIm5iZiI6MTYzNzkyNzAxN30.SLfpcDwuFBXoAcLMnzqvykxPPqy0YaTNZYoq325cYac";
				this.$api.setToken(t);
			},
		},
	};
</script>



<style>
	.body {
		height: 100vh;
		overflow-x: hidden;
		overflow-y: scroll;
		background: #f9f9f9 url('https://img.hsnms.com/20211112/1636716669.png') bottom no-repeat;
		background-size: 100% auto;
	}
</style>


// WEBPACK FOOTER //
// src/components/views/jjgh/_layout/template.vue